export default async (to, from, next) => {
    const maintenance = process.env.VUE_APP_MAINTENANCE_MODE

    if (maintenance == 1 && to.name != 'maintenance') {
        return window.location.href = "/maintenance"
    }
    return next();
};
